export const EVENT_TYPE_LABEL = {
  Pick: 'Pick',
  Pack: 'Pack',
  Ship: 'Ship',
  Box: 'Box',
  Receive: 'Receive',
  Return: 'Return',
  Storage: 'Storage',
  Ownership: 'Monthly Ownership',
  KitAssembly: 'Kit Assembly',
  Transfer: 'Transfer',
  LotTracking: 'Lot Tracking',
  Disposal: 'Disposal',
  CycleCount: 'Cycle Count',
  Adjustment: 'Adjustment',
  Misc: 'Misc',
  Packaging: 'Packaging',
  ReturnInspection: 'Return Inspection',
  Insurance: 'Insurance',
  ShippingAdjustment: 'Shipping Adjustments',
};

// Fallback for unrecognized event types: split camelCase / snake / kebab
// into words and title-case them (e.g. "handlingFee" -> "Handling Fee").
const titleCaseEventType = (t) =>
  String(t)
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim()
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

export const labelForEventType = (t) => EVENT_TYPE_LABEL[t] ?? (t ? titleCaseEventType(t) : '—');

// Human-readable context for rows whose reference/description indicate a
// card surcharge or a monthly-minimum top-up (Adjustment rows written by the
// billing engine with references like "card-surcharge:123" or
// "storage-minimum:2026-06").
export const referenceContext = (referenceId) => {
  const ref = String(referenceId ?? '');
  const surchargeMatch = ref.match(/^card-surcharge:(.*)$/i);
  if (surchargeMatch) {
    const inv = surchargeMatch[1];
    return /^\d+$/.test(inv)
      ? `Card payment surcharge for INV-${String(inv).padStart(5, '0')}`
      : 'Card payment surcharge';
  }
  const minMatch = ref.match(/^([a-z0-9]+)-minimum:(.*)$/i);
  if (minMatch) {
    const category = titleCaseEventType(minMatch[1]);
    const period = minMatch[2];
    return `${category} monthly minimum top-up${period ? ` (${period})` : ''}`;
  }
  return null;
};
